/**
 * Web platform entry point
 */

import React from 'react';
import {render} from 'react-native';
import './index.css';

import App from './App'


render(<App/>, document.getElementById('root'));
